import { HTMLAttributes } from "react"

export default function Firebase(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2563 30.195L14.2613 4.53C14.4 3.65625 15.5738 3.44625 15.9863 4.23L20.2913 12.285L10.2563 30.195ZM38.7338 36.4313L34.9125 12.7913C34.7963 12.0563 33.8775 11.7562 33.3488 12.285L9.26625 36.4313L22.5938 43.9125C23.0062 44.1394 23.4693 44.2584 23.94 44.2584C24.4107 44.2584 24.8738 44.1394 25.2863 43.9125L38.7338 36.4313ZM27.915 15.8063L24.8288 9.9375C24.4838 9.27 23.5388 9.27 23.1938 9.9375L9.6375 34.1063L27.915 15.8063Z"
        fill="#F58220"
      />
    </svg>
  )
}
